var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgByblogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 158.777,
    viewBox: "0 0 256 158.777",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160587",
    "data-name": "Group 160587",
    transform: "translate(-29 -27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160433",
    "data-name": "Group 160433",
    transform: "translate(29 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(143.341 56.438)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M396.769,182.137c0-8.414-5.837-14.591-15.269-14.591H360.33v45.261h16.939v-16.08h-.249l8.891,16.08h11.128l-10.248-17.236c4.889-1.15,9.978-5.493,9.978-13.435",
    transform: "translate(-360.33 -167.546)",
    fill: "#efab4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M288.424,169.167H254.138V195.7c0,10.94,6.5,18.5,19.964,18.5s19.96-7.56,19.96-18.5v-26.53Z",
    transform: "translate(-158.642 -111.999)",
    fill: "#f08089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M159.974,167.546c-13.394,0-23.146,9.548-23.146,22.879s9.752,22.884,23.146,22.884c13.331,0,23.082-9.549,23.082-22.884s-9.752-22.879-23.082-22.879",
    transform: "translate(-94.186 -111.108)",
    fill: "#76578f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M42.184,169.167l16.977,26.128V213.4h9.417V195.295l16.914-26.128Z",
    transform: "translate(-42.184 -111.999)",
    fill: "#576298"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 113.516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M71.227,316.15c4.883.748,8.684,5.429,8.684,11.059,0,6.856-4.474,12.284-13.164,12.284H42.184V294.232H66c8.621,0,13.032,5.493,13.032,11.531,0,5.636-3.531,9.507-7.8,10.387",
    transform: "translate(-42.184 -294.232)",
    fill: "#90bf5c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M244.982,294.227l-17.443,45.261H274.5l-17.443-45.261Z",
    transform: "translate(-144.027 -180.713)",
    fill: "#4694ae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(44.111 113.514)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M176.527,308.817c0-8.414-5.837-14.591-15.269-14.591h-21.17v45.261h16.939v-16.08h-.249l8.891,16.08H176.8l-10.248-17.236c4.889-1.15,9.978-5.492,9.978-13.435",
    transform: "translate(-140.088 -294.226)",
    fill: "#e1d159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(46.621 0.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M182.1,57.271c0-8.414-5.837-14.59-15.269-14.59h-21.17V87.942H162.6V71.862h-.249l8.891,16.08h11.128L172.12,70.706c4.888-1.15,9.978-5.492,9.978-13.435",
    transform: "translate(-145.659 -42.681)",
    fill: "#efab4d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M42.184,87.84V42.681H67.776c8.937,0,13.2,5.822,13.2,11.509,0,5.62-3.453,9.411-7.718,10.359,4.807.745,8.6,5.349,8.6,11.036,0,6.567-4.4,12.255-13.27,12.255Z",
    transform: "translate(-42.184 -42.502)",
    fill: "#f08089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M275.838,87.84H241.22V42.681h34.618V52.5h-9.355v7.515h9.355V69.9h-9.355v8.125h9.355Z",
    transform: "translate(-151.544 -42.501)",
    fill: "#e1d159"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(130.723 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M390,68.847l-9.433,18.94L367.714,61.975l-.051-.1-12.74,25.788-.115-.23L332.323,42.284h46.06Z",
    transform: "translate(-332.323 -42.283)",
    fill: "#4694ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M457.193,42.283h14.648L465.194,55.63l-1.152,2.313Z",
    transform: "translate(-400.933 -42.283)",
    fill: "#4694ae"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M491.693,316.823c0,13.711-9.84,22.665-23.953,22.665H451.822L471.47,319.84v10.4h5.768V309.992H456.995v5.768h10.4l-17.566,17.566v-39.1h17.846C481.853,294.227,491.693,303.251,491.693,316.823Z",
    transform: "translate(-266.161 -180.713)",
    fill: "#76578f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M374.9,294.226h-5.109v10.912l-10.912-10.912H344.022v45.261H358.77V328.769l10.719,10.719h15.05V294.226Z",
    transform: "translate(-208.028 -180.713)",
    fill: "#576298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_160564",
    "data-name": "Group 160564",
    transform: "translate(257.934 141.462)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37585",
    "data-name": "Path 37585",
    d: "M359.7,1.935H355.14V.29h10.949V1.935h-4.558V13.541h-1.88V1.935Z",
    transform: "translate(-355.14 -0.29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37586",
    "data-name": "Path 37586",
    d: "M370.175,13.541V3.861L365.381,11.9h-.846l-4.793-7.988v9.586H357.91V.29h1.55l5.5,9.3,5.451-9.3h1.551V13.541Z",
    transform: "translate(-344.894 -0.29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgByblogo);
export default __webpack_public_path__ + "static/media/byblogo.715e3cc20746dc771288c67196202ebb.svg";
export { ForwardRef as ReactComponent };